import {
  Stack,
  // Typography
} from '@mui/material'
import { useAction } from '../../containers/facilityReservationTodayConditionInputConfirmation/facilityReservationTodayConditionInputConfirmationService'
import { GContainer, GItem, RowSpacerGItem } from '../components/common/grids'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { ButtonL } from '../components/common/buttons/buttonL'
import { BackButton } from '../components/common/buttons/backButton'
import { getClassificationLabel, translate } from '../../i18n'
import { StepBar } from '../components/common/stepBar'
import { InfoCard } from '../components/common/infoCard'
import { LabelGItem, ValueGItem } from '../components/common/reservationDetail/reservationDetailParts'
import { PostDecodeMstDto } from '../../dataAccess/webApi/dto/decodeMstDto'
import { todayConditionInputFieldUsage } from '../../containers/common/constant/classification'
// import styled from '@emotion/styled'

// const SectionText = styled(Typography)(() => ({
//   fontSize: '21px',
//   marginTop: '10px',
// }))

export const FacilityReservationTodayConditionInputConfirmation = () => {
  const { todayConditionInputDecodeMst, reservationInfo, todayConditionInputFieldsInfo, input, regResultCode, decide } =
    useAction()

  const getValueLabels = (decodeItems: PostDecodeMstDto[]): { value: string; label: string }[] => {
    return decodeItems.map((item) => {
      return {
        value: item.code,
        label: item.name,
      }
    })
  }

  const napTypeValueLabels = todayConditionInputDecodeMst ? getValueLabels(todayConditionInputDecodeMst.napType) : null
  const defecationTimingValueLabels = todayConditionInputDecodeMst
    ? getValueLabels(todayConditionInputDecodeMst.defecationTiming)
    : null
  const defecationConditionValueLabels = todayConditionInputDecodeMst
    ? getValueLabels(todayConditionInputDecodeMst.defecationCondition)
    : null
  const eatingMethodValueLabels = todayConditionInputDecodeMst
    ? getValueLabels(todayConditionInputDecodeMst.eatingMethod)
    : null
  const amountOfFoodValueLabels = todayConditionInputDecodeMst
    ? getValueLabels(todayConditionInputDecodeMst.amountOfFood)
    : null
  const brestFeedingDetailValueLabels = todayConditionInputDecodeMst
    ? getValueLabels(todayConditionInputDecodeMst.brestFeedingDetail)
    : null
  const escortTypeValueLabels = todayConditionInputDecodeMst
    ? getValueLabels(todayConditionInputDecodeMst.escortType)
    : null
  const belongingsValueLabels = todayConditionInputDecodeMst
    ? getValueLabels(todayConditionInputDecodeMst.belongings)
    : null

  console.log(regResultCode)

  const getLabelByValue = (valueLabels: { value: string; label: string }[] | null, value: string): string => {
    if (!valueLabels) {
      return ''
    }
    const valueLabel = valueLabels.find((valueLabel) => valueLabel.value === value)
    return valueLabel ? valueLabel.label : ''
  }

  const getYesNoLabel = (value: string) => {
    return getClassificationLabel('facilityReservationTodayConditionInput.form.common.yesNo', value)
  }

  return (
    <>
      <Stack spacing={2}>
        <GContainer justifyContent={'center'}>
          <GItem xs={12} md={6}>
            <StepBar
              activeStepValue="②"
              stepValueLabels={[
                { value: '①', label: '必要事項入力' },
                { value: '②', label: '入力内容確認' },
                { value: '③', label: '完了' },
              ]}
            />
            <Stack spacing={2}>
              {reservationInfo && (
                <InfoCard>
                  <GContainer>
                    {/* 施設名 */}
                    <LabelGItem>{translate('facilityReservationTodayConditionInput.view.facilityName')}</LabelGItem>
                    <ValueGItem>{reservationInfo.facilityName}</ValueGItem>

                    <RowSpacerGItem />

                    {/* ご利用目的 */}
                    <LabelGItem>{translate('facilityReservationTodayConditionInput.view.useReason')}</LabelGItem>
                    <ValueGItem>{reservationInfo.displayNameForCitizenIrregular}</ValueGItem>
                    {/* 利用日 */}
                    <LabelGItem>{translate('facilityReservationTodayConditionInput.view.usageDate')}</LabelGItem>
                    <ValueGItem>{reservationInfo.usageDate}</ValueGItem>
                    {/* 利用時間 */}
                    <LabelGItem>{translate('facilityReservationTodayConditionInput.view.usageDateTime')}</LabelGItem>
                    <ValueGItem>{`${reservationInfo.useFromDatetime}～${reservationInfo.useToDatetime}`}</ValueGItem>

                    <RowSpacerGItem />

                    {/* 保護者 */}
                    <LabelGItem>{translate('facilityReservationTodayConditionInput.view.userName')}</LabelGItem>
                    <ValueGItem>{reservationInfo.userName}</ValueGItem>
                    {/* フリガナ */}
                    <LabelGItem>{translate('facilityReservationTodayConditionInput.view.userKana')}</LabelGItem>
                    <ValueGItem>{reservationInfo.userKana}</ValueGItem>
                    {/* お子さま */}
                    <LabelGItem>{translate('facilityReservationTodayConditionInput.view.childName')}</LabelGItem>
                    <ValueGItem>{reservationInfo.childName}</ValueGItem>
                    {/* フリガナ */}
                    <LabelGItem>{translate('facilityReservationTodayConditionInput.view.childKana')}</LabelGItem>
                    <ValueGItem>{reservationInfo.childKana}</ValueGItem>
                    {/* 生年月日 */}
                    <LabelGItem>{translate('facilityReservationTodayConditionInput.view.childBirthday')}</LabelGItem>
                    <ValueGItem>{reservationInfo.childBirthday}</ValueGItem>
                  </GContainer>
                </InfoCard>
              )}
              {input && (
                <InfoCard>
                  <GContainer>
                    {/* 体温（登園前） */}
                    {todayConditionInputFieldsInfo?.morningBodyTemperature !== todayConditionInputFieldUsage.noUse &&
                      input.morningBodyTemperature && (
                        <>
                          <LabelGItem>
                            {translate(
                              'facilityReservationTodayConditionInput.form.label.morningBodyTemperature.field'
                            )}
                          </LabelGItem>
                          <ValueGItem>{input.morningBodyTemperature}</ValueGItem>
                        </>
                      )}
                    {/* 計測時刻（登園前） */}
                    {todayConditionInputFieldsInfo?.morningBodyTemperature !== todayConditionInputFieldUsage.noUse &&
                      input.morningBodyTemperature && (
                        <>
                          <LabelGItem>
                            {translate(
                              'facilityReservationTodayConditionInput.form.label.morningBodyTemperatureMeasurementTime'
                            )}
                          </LabelGItem>
                          <ValueGItem>{input.morningBodyTemperatureMeasurementTime}</ValueGItem>
                        </>
                      )}
                    {/* 体温（朝） */}
                    {todayConditionInputFieldsInfo?.afterComingBodyTemperature !==
                      todayConditionInputFieldUsage.noUse &&
                      input.afterComingAmBodyTemperature && (
                        <>
                          <LabelGItem>
                            {translate(
                              'facilityReservationTodayConditionInput.form.label.afterComingAmBodyTemperature.field'
                            )}
                          </LabelGItem>
                          <ValueGItem>{input.afterComingAmBodyTemperature}</ValueGItem>
                        </>
                      )}
                    {/* 体温（夕） */}
                    {todayConditionInputFieldsInfo?.afterComingBodyTemperature !==
                      todayConditionInputFieldUsage.noUse &&
                      input.afterComingPmBodyTemperature && (
                        <>
                          <LabelGItem>
                            {translate(
                              'facilityReservationTodayConditionInput.form.label.afterComingPmBodyTemperature.field'
                            )}
                          </LabelGItem>
                          <ValueGItem>{input.afterComingPmBodyTemperature}</ValueGItem>
                        </>
                      )}
                    {/* 咳をしていますか */}
                    {todayConditionInputFieldsInfo?.cough !== todayConditionInputFieldUsage.noUse && input.cough && (
                      <>
                        <LabelGItem>{translate('facilityReservationTodayConditionInput.form.label.cough')}</LabelGItem>
                        <ValueGItem>{getYesNoLabel(input.cough)}</ValueGItem>
                      </>
                    )}
                    {/* 咳に関する備考 */}
                    {todayConditionInputFieldsInfo?.cough !== todayConditionInputFieldUsage.noUse &&
                      input.coughNote && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.coughNote')}
                          </LabelGItem>
                          <ValueGItem>{input.coughNote}</ValueGItem>
                        </>
                      )}
                    {/* 鼻水がでていますか */}
                    {todayConditionInputFieldsInfo?.runnyNose !== todayConditionInputFieldUsage.noUse &&
                      input.runnyNose && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.runnyNose')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.runnyNose)}</ValueGItem>
                        </>
                      )}
                    {/* 鼻水に関する備考 */}
                    {todayConditionInputFieldsInfo?.runnyNose !== todayConditionInputFieldUsage.noUse &&
                      input.runnyNoseNote && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.runnyNoseNote')}
                          </LabelGItem>
                          <ValueGItem>{input.runnyNoseNote}</ValueGItem>
                        </>
                      )}
                    {/* 湿疹がでていますか */}
                    {todayConditionInputFieldsInfo?.eczema !== todayConditionInputFieldUsage.noUse && input.eczema && (
                      <>
                        <LabelGItem>{translate('facilityReservationTodayConditionInput.form.label.eczema')}</LabelGItem>
                        <ValueGItem>{getYesNoLabel(input.eczema)}</ValueGItem>
                      </>
                    )}
                    {/* 使用している軟膏名 */}
                    {todayConditionInputFieldsInfo?.eczema !== todayConditionInputFieldUsage.noUse &&
                      input.eczemaName && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.eczemaName')}
                          </LabelGItem>
                          <ValueGItem>{input.eczemaName}</ValueGItem>
                        </>
                      )}
                    {/* アレルギーがありますか */}
                    {todayConditionInputFieldsInfo?.allergy !== todayConditionInputFieldUsage.noUse &&
                      input.allergy && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.allergy')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.allergy)}</ValueGItem>
                        </>
                      )}
                    {/* アレルギーに関する備考 */}
                    {todayConditionInputFieldsInfo?.allergy !== todayConditionInputFieldUsage.noUse &&
                      input.allergyNote && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.allergyNote')}
                          </LabelGItem>
                          <ValueGItem>{input.allergyNote}</ValueGItem>
                        </>
                      )}
                    {/* 食物アレルギーがありますか */}
                    {todayConditionInputFieldsInfo?.foodAllergy !== todayConditionInputFieldUsage.noUse &&
                      input.foodAllergy && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.foodAllergy')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.foodAllergy)}</ValueGItem>
                        </>
                      )}
                    {/* 食物アレルギーに関する備考 */}
                    {todayConditionInputFieldsInfo?.foodAllergy !== todayConditionInputFieldUsage.noUse &&
                      input.foodAllergyNote && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.foodAllergyNote')}
                          </LabelGItem>
                          <ValueGItem>{input.foodAllergyNote}</ValueGItem>
                        </>
                      )}
                    {/* 薬を飲んでいますか */}
                    {todayConditionInputFieldsInfo?.medicine !== todayConditionInputFieldUsage.noUse &&
                      input.medicine && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.medicine')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.medicine)}</ValueGItem>
                        </>
                      )}
                    {/* 服用している薬名 */}
                    {todayConditionInputFieldsInfo?.medicine !== todayConditionInputFieldUsage.noUse &&
                      input.medicineName && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.medicineName')}
                          </LabelGItem>
                          <ValueGItem>{input.medicineName}</ValueGItem>
                        </>
                      )}
                    {/* 機嫌は良いですか */}
                    {todayConditionInputFieldsInfo?.mood !== todayConditionInputFieldUsage.noUse && input.mood && (
                      <>
                        <LabelGItem>{translate('facilityReservationTodayConditionInput.form.label.mood')}</LabelGItem>
                        <ValueGItem>{getYesNoLabel(input.mood)}</ValueGItem>
                      </>
                    )}
                    {/* 機嫌に関する備考 */}
                    {todayConditionInputFieldsInfo?.mood !== todayConditionInputFieldUsage.noUse && input.moodNote && (
                      <>
                        <LabelGItem>
                          {translate('facilityReservationTodayConditionInput.form.label.moodNote')}
                        </LabelGItem>
                        <ValueGItem>{input.moodNote}</ValueGItem>
                      </>
                    )}
                    {/* いままで病気にかかったことはありますか */}
                    {todayConditionInputFieldsInfo?.disease !== todayConditionInputFieldUsage.noUse &&
                      input.disease && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.disease')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.disease)}</ValueGItem>
                        </>
                      )}
                    {/* 1か月以内にかかった病気ですか */}
                    {todayConditionInputFieldsInfo?.disease !== todayConditionInputFieldUsage.noUse &&
                      input.diseaseWithinMonth && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.diseaseWithinMonth.field')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.diseaseWithinMonth)}</ValueGItem>
                        </>
                      )}
                    {/* 病気に関する備考 */}
                    {todayConditionInputFieldsInfo?.disease !== todayConditionInputFieldUsage.noUse &&
                      input.diseaseNote && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.diseaseNote')}
                          </LabelGItem>
                          <ValueGItem>{input.diseaseNote}</ValueGItem>
                        </>
                      )}
                    {/* 予防接種を受けましたか */}
                    {todayConditionInputFieldsInfo?.vaccine !== todayConditionInputFieldUsage.noUse &&
                      input.vaccine && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.vaccine')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.vaccine)}</ValueGItem>
                        </>
                      )}
                    {/* 予防接種をいつ受けましたか */}
                    {todayConditionInputFieldsInfo?.vaccine !== todayConditionInputFieldUsage.noUse &&
                      input.vaccineMonthsAgo && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.vaccineMonthsAgo.field')}
                          </LabelGItem>
                          <ValueGItem>{`${input.vaccineMonthsAgo}${translate(
                            'facilityReservationTodayConditionInput.form.label.vaccineMonthsAgo.unit'
                          )}`}</ValueGItem>
                        </>
                      )}
                    {/* 予防接種に関する備考 */}
                    {todayConditionInputFieldsInfo?.vaccine !== todayConditionInputFieldUsage.noUse &&
                      input.vaccineNote && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.vaccineNote')}
                          </LabelGItem>
                          <ValueGItem>{input.vaccineNote}</ValueGItem>
                        </>
                      )}
                    {/* 病院を受診しましたか */}
                    {todayConditionInputFieldsInfo?.hospitalVisit !== todayConditionInputFieldUsage.noUse &&
                      input.hospitalVisit && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.hospitalVisit')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.hospitalVisit)}</ValueGItem>
                        </>
                      )}
                    {/* 病院をいつ受診しましたか */}
                    {todayConditionInputFieldsInfo?.hospitalVisit !== todayConditionInputFieldUsage.noUse &&
                      input.hospitalVisitMonthsAgo && (
                        <>
                          <LabelGItem>
                            {translate(
                              'facilityReservationTodayConditionInput.form.label.hospitalVisitMonthsAgo.field'
                            )}
                          </LabelGItem>
                          <ValueGItem>{`${input.hospitalVisitMonthsAgo}${translate(
                            'facilityReservationTodayConditionInput.form.label.hospitalVisitMonthsAgo.unit'
                          )}`}</ValueGItem>
                        </>
                      )}
                    {/* 病院受診に関する備考 */}
                    {todayConditionInputFieldsInfo?.hospitalVisit !== todayConditionInputFieldUsage.noUse &&
                      input.hospitalVisitNote && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.hospitalVisitNote')}
                          </LabelGItem>
                          <ValueGItem>{input.hospitalVisitNote}</ValueGItem>
                        </>
                      )}
                    {/* 感染症に関する該当事項に該当しますか */}
                    {todayConditionInputFieldsInfo?.infection !== todayConditionInputFieldUsage.noUse &&
                      input.infection && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.infection')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.infection)}</ValueGItem>
                        </>
                      )}
                    {/* 感染症に関する備考 */}
                    {todayConditionInputFieldsInfo?.infection !== todayConditionInputFieldUsage.noUse &&
                      input.infectionNote && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.infectionNote')}
                          </LabelGItem>
                          <ValueGItem>{input.infectionNote}</ValueGItem>
                        </>
                      )}
                    {/* 本日の体調で気になることはありますか */}
                    {todayConditionInputFieldsInfo?.todayConditionPoint !== todayConditionInputFieldUsage.noUse &&
                      input.todayConditionPoint && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.todayConditionPoint')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.todayConditionPoint)}</ValueGItem>
                        </>
                      )}
                    {/* 本日の体調に関する備考 */}
                    {todayConditionInputFieldsInfo?.todayConditionPoint !== todayConditionInputFieldUsage.noUse &&
                      input.todayConditionPointNote && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.todayConditionPointNote')}
                          </LabelGItem>
                          <ValueGItem>{input.todayConditionPointNote}</ValueGItem>
                        </>
                      )}
                    {/* 保育園で散歩に連れて行くことは可能ですか */}
                    {todayConditionInputFieldsInfo?.stroll !== todayConditionInputFieldUsage.noUse && input.stroll && (
                      <>
                        <LabelGItem>{translate('facilityReservationTodayConditionInput.form.label.stroll')}</LabelGItem>
                        <ValueGItem>{getYesNoLabel(input.stroll)}</ValueGItem>
                      </>
                    )}
                    <RowSpacerGItem />

                    {/* 昨夜はよく眠りましたか */}
                    {todayConditionInputFieldsInfo?.lastNightSleep !== todayConditionInputFieldUsage.noUse &&
                      input.lastNightSleep && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.lastNightSleep')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.lastNightSleep)}</ValueGItem>
                        </>
                      )}
                    {/* 昨夜の就寝時刻 */}
                    {todayConditionInputFieldsInfo?.lastNightSleep !== todayConditionInputFieldUsage.noUse &&
                      input.lastNightFromTime && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.lastNightFromTime')}
                          </LabelGItem>
                          <ValueGItem>{input.lastNightFromTime}</ValueGItem>
                        </>
                      )}
                    {/* 今朝の起床時刻 */}
                    {todayConditionInputFieldsInfo?.lastNightSleep !== todayConditionInputFieldUsage.noUse &&
                      input.lastNightToTime && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.lastNightToTime')}
                          </LabelGItem>
                          <ValueGItem>{input.lastNightToTime}</ValueGItem>
                        </>
                      )}
                    {/* 普段お昼寝をしますか */}
                    {todayConditionInputFieldsInfo?.nap !== todayConditionInputFieldUsage.noUse && input.nap && (
                      <>
                        <LabelGItem>{translate('facilityReservationTodayConditionInput.form.label.nap')}</LabelGItem>
                        <ValueGItem>{getYesNoLabel(input.nap)}</ValueGItem>
                      </>
                    )}
                    {/* お昼寝の種類 */}
                    {todayConditionInputFieldsInfo?.nap !== todayConditionInputFieldUsage.noUse && input.napType && (
                      <>
                        <LabelGItem>
                          {translate('facilityReservationTodayConditionInput.form.label.napType')}
                        </LabelGItem>
                        <ValueGItem>{getLabelByValue(napTypeValueLabels, input.napType)}</ValueGItem>
                      </>
                    )}
                    {/* 午前睡眠開始時刻 */}
                    {todayConditionInputFieldsInfo?.nap !== todayConditionInputFieldUsage.noUse &&
                      input.napAmFromTime && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.napAmFromTime')}
                          </LabelGItem>
                          <ValueGItem>{input.napAmFromTime}</ValueGItem>
                        </>
                      )}
                    {/* 午前睡眠終了時刻 */}
                    {todayConditionInputFieldsInfo?.nap !== todayConditionInputFieldUsage.noUse &&
                      input.napAmToTime && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.napAmToTime')}
                          </LabelGItem>
                          <ValueGItem>{input.napAmToTime}</ValueGItem>
                        </>
                      )}
                    {/* 午後睡眠開始時刻 */}
                    {todayConditionInputFieldsInfo?.nap !== todayConditionInputFieldUsage.noUse &&
                      input.napPmFromTime && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.napPmFromTime')}
                          </LabelGItem>
                          <ValueGItem>{input.napPmFromTime}</ValueGItem>
                        </>
                      )}
                    {/* 午後睡眠終了時刻 */}
                    {todayConditionInputFieldsInfo?.nap !== todayConditionInputFieldUsage.noUse &&
                      input.napPmToTime && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.napPmToTime')}
                          </LabelGItem>
                          <ValueGItem>{input.napPmToTime}</ValueGItem>
                        </>
                      )}
                    <RowSpacerGItem />

                    {/* いつ排便をしましたか */}
                    {todayConditionInputFieldsInfo?.defecation !== todayConditionInputFieldUsage.noUse &&
                      input.defecationTiming && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.defecationTiming')}
                          </LabelGItem>
                          <ValueGItem>
                            {getLabelByValue(defecationTimingValueLabels, input.defecationTiming)}
                          </ValueGItem>
                        </>
                      )}
                    {/* 排便時刻 */}
                    {todayConditionInputFieldsInfo?.defecation !== todayConditionInputFieldUsage.noUse &&
                      input.defecationHours && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.defecationHours.field')}
                          </LabelGItem>
                          <ValueGItem>{`${input.defecationHours}${translate(
                            'facilityReservationTodayConditionInput.form.label.defecationHours.unit'
                          )}`}</ValueGItem>
                        </>
                      )}
                    {/* 排便日 */}
                    {todayConditionInputFieldsInfo?.defecation !== todayConditionInputFieldUsage.noUse &&
                      input.defecationDaysAgo && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.defecationDaysAgo.field')}
                          </LabelGItem>
                          <ValueGItem>{`${input.defecationDaysAgo}${translate(
                            'facilityReservationTodayConditionInput.form.label.defecationDaysAgo.unit'
                          )}`}</ValueGItem>
                        </>
                      )}
                    {/* 便の状態 */}
                    {todayConditionInputFieldsInfo?.defecation !== todayConditionInputFieldUsage.noUse &&
                      input.defecationCondition && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.defecationCondition')}
                          </LabelGItem>
                          <ValueGItem>
                            {getLabelByValue(defecationConditionValueLabels, input.defecationCondition)}
                          </ValueGItem>
                        </>
                      )}
                    <RowSpacerGItem />

                    {/* 食事 */}
                    {todayConditionInputFieldsInfo?.meal !== todayConditionInputFieldUsage.noUse && input.meal && (
                      <>
                        <LabelGItem>{translate('facilityReservationTodayConditionInput.form.label.meal')}</LabelGItem>
                        <ValueGItem>{getYesNoLabel(input.meal)}</ValueGItem>
                      </>
                    )}
                    {/* 食事時刻 */}
                    {todayConditionInputFieldsInfo?.meal !== todayConditionInputFieldUsage.noUse && input.mealTime && (
                      <>
                        <LabelGItem>
                          {translate('facilityReservationTodayConditionInput.form.label.mealTime')}
                        </LabelGItem>
                        <ValueGItem>{input.mealTime}</ValueGItem>
                      </>
                    )}
                    {/* 栄養方法 */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.eatingMethod && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.eatingMethod')}
                          </LabelGItem>
                          <ValueGItem>{getLabelByValue(eatingMethodValueLabels, input.eatingMethod)}</ValueGItem>
                        </>
                      )}
                    {/* 朝食を食べましたか */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.breakfast && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.breakfast')}
                          </LabelGItem>
                          <ValueGItem>{getLabelByValue(amountOfFoodValueLabels, input.breakfast)}</ValueGItem>
                        </>
                      )}
                    {/* 朝食時刻 */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.breakfastTime && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.breakfastTime')}
                          </LabelGItem>
                          <ValueGItem>{input.breakfastTime}</ValueGItem>
                        </>
                      )}
                    {/* 朝食は何を食べましたか */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.breakfastWhat && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.breakfastWhat')}
                          </LabelGItem>
                          <ValueGItem>{input.breakfastWhat}</ValueGItem>
                        </>
                      )}
                    {/* 昼食を食べましたか */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.lunch && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.lunch')}
                          </LabelGItem>
                          <ValueGItem>{getLabelByValue(amountOfFoodValueLabels, input.lunch)}</ValueGItem>
                        </>
                      )}
                    {/* 昼食時刻 */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.lunchTime && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.lunchTime')}
                          </LabelGItem>
                          <ValueGItem>{input.lunchTime}</ValueGItem>
                        </>
                      )}
                    {/* 昼食は何を食べましたか */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.lunchWhat && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.lunchWhat')}
                          </LabelGItem>
                          <ValueGItem>{input.lunchWhat}</ValueGItem>
                        </>
                      )}
                    {/* おやつは食べましたか */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.snack && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.snack')}
                          </LabelGItem>
                          <ValueGItem>{getYesNoLabel(input.snack)}</ValueGItem>
                        </>
                      )}
                    {/* おやつ時刻 */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.snackTime && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.snackTime')}
                          </LabelGItem>
                          <ValueGItem>{input.snackTime}</ValueGItem>
                        </>
                      )}
                    {/* 栄養方法詳細 */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.eatingMethodDetail && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.eatingMethodDetail')}
                          </LabelGItem>
                          <ValueGItem>
                            {getLabelByValue(brestFeedingDetailValueLabels, input.eatingMethodDetail)}
                          </ValueGItem>
                        </>
                      )}
                    {/* ミルク量 */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.milkAmount && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.milkAmount.field')}
                          </LabelGItem>
                          <ValueGItem>{input.milkAmount}</ValueGItem>
                        </>
                      )}
                    {/* ミルク接種時刻 */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.milkTime && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.milkTime')}
                          </LabelGItem>
                          <ValueGItem>{input.milkTime}</ValueGItem>
                        </>
                      )}
                    {/* 母乳接種時刻 */}
                    {todayConditionInputFieldsInfo?.mealDetail !== todayConditionInputFieldUsage.noUse &&
                      input.breastMilkTime && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.breastMilkTime')}
                          </LabelGItem>
                          <ValueGItem>{input.breastMilkTime}</ValueGItem>
                        </>
                      )}
                    <RowSpacerGItem />

                    {/* 送迎者種類 */}
                    {todayConditionInputFieldsInfo?.escort !== todayConditionInputFieldUsage.noUse &&
                      input.escortType && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.escortType')}
                          </LabelGItem>
                          <ValueGItem>{getLabelByValue(escortTypeValueLabels, input.escortType)}</ValueGItem>
                        </>
                      )}
                    {/* 送迎者2氏名 */}
                    {todayConditionInputFieldsInfo?.escort !== todayConditionInputFieldUsage.noUse &&
                      input.escort1Name && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.escort1Name')}
                          </LabelGItem>
                          <ValueGItem>{input.escort1Name}</ValueGItem>
                        </>
                      )}
                    {/* 送迎者2続柄 */}
                    {todayConditionInputFieldsInfo?.escort !== todayConditionInputFieldUsage.noUse &&
                      input.escort1Relationship && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.escort1Relationship')}
                          </LabelGItem>
                          <ValueGItem>{input.escort1Relationship}</ValueGItem>
                        </>
                      )}
                    {/* 送迎者2電話番号 */}
                    {todayConditionInputFieldsInfo?.escort !== todayConditionInputFieldUsage.noUse &&
                      input.escort1Tel && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.escort1Tel')}
                          </LabelGItem>
                          <ValueGItem>{input.escort1Tel}</ValueGItem>
                        </>
                      )}
                    {/* 送迎者2氏名 */}
                    {todayConditionInputFieldsInfo?.escort !== todayConditionInputFieldUsage.noUse &&
                      input.escort2Name && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.escort2Name')}
                          </LabelGItem>
                          <ValueGItem>{input.escort2Name}</ValueGItem>
                        </>
                      )}
                    {/* 送迎者2続柄 */}
                    {todayConditionInputFieldsInfo?.escort !== todayConditionInputFieldUsage.noUse &&
                      input.escort2Relationship && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.escort2Relationship')}
                          </LabelGItem>
                          <ValueGItem>{input.escort2Relationship}</ValueGItem>
                        </>
                      )}
                    {/* 送迎者2電話番号 */}
                    {todayConditionInputFieldsInfo?.escort !== todayConditionInputFieldUsage.noUse &&
                      input.escort2Tel && (
                        <>
                          <LabelGItem>
                            {translate('facilityReservationTodayConditionInput.form.label.escort2Tel')}
                          </LabelGItem>
                          <ValueGItem>{input.escort2Tel}</ValueGItem>
                        </>
                      )}
                    {/* 持ち物 */}
                    {input.belongings && (
                      <>
                        <LabelGItem>
                          {translate('facilityReservationTodayConditionInput.form.label.belongings')}
                        </LabelGItem>
                        <ValueGItem>
                          {input.belongings
                            .split(',')
                            .map((item) => getLabelByValue(belongingsValueLabels, item))
                            .join(',')}
                        </ValueGItem>
                      </>
                    )}
                    {/* 何回分のミルクを持たせましたか */}
                    {input.belongingsMilkCount && (
                      <>
                        <LabelGItem>
                          {translate('facilityReservationTodayConditionInput.form.label.belongingsMilkCount.field')}
                        </LabelGItem>
                        <ValueGItem>{input.belongingsMilkCount}</ValueGItem>
                      </>
                    )}
                    {/* どれくらいのお湯でミルクを溶かしますか */}
                    {input.belongingsMilkDissolveHotWater && (
                      <>
                        <LabelGItem>
                          {translate(
                            'facilityReservationTodayConditionInput.form.label.belongingsMilkDissolveHotWater.field'
                          )}
                        </LabelGItem>
                        <ValueGItem>{input.belongingsMilkDissolveHotWater}</ValueGItem>
                      </>
                    )}
                    {/* 持ち物（その他） */}
                    {input.belongingsOther && (
                      <>
                        <LabelGItem>
                          {translate('facilityReservationTodayConditionInput.form.label.belongingsOther')}
                        </LabelGItem>
                        <ValueGItem>{input.belongingsOther}</ValueGItem>
                      </>
                    )}
                    {/* 備考 */}
                    {input.note && (
                      <>
                        <LabelGItem>{translate('facilityReservationTodayConditionInput.form.label.note')}</LabelGItem>
                        <ValueGItem>{input.note}</ValueGItem>
                      </>
                    )}
                  </GContainer>
                </InfoCard>
              )}
            </Stack>
          </GItem>
        </GContainer>

        {/* 画面下部ボタングループ */}
        <BottomButtonGroup>
          <ButtonL onClick={decide} fullWidth>
            {input ? (input.updateDateTime ? '更新' : '登録') : ''}
          </ButtonL>
          <BackButton />
        </BottomButtonGroup>
      </Stack>
    </>
  )
}
